import React, { useEffect } from 'react'
import CatSection from '../../components/PageComps/HomeComps/CatSection/CatSection'
import BrowseCat from '../../components/PageComps/HomeComps/BrowseCat/BrowseCat'
import Hero from '../../components/PageComps/HomeComps/Hero/Hero'
import PopularProd from '../../components/PageComps/HomeComps/PopularProd/PopularProd'
import Features from '../../components/PageComps/HomeComps/Features/Features'
import AboutSection from '../../components/PageComps/HomeComps/AboutSection/AboutSection'
import Feautred from '../../components/PageComps/HomeComps/Featured/Featured'
import Carousel from '../../components/PageComps/HomeComps/Carousel/Carousel'
import { getAppearencesThunk } from '../../redux/appearancesSlice'
import { useDispatch, useSelector } from 'react-redux'
import styles from './home.module.css'

const Home = () => {

  const { appearences, loading } = useSelector((state) => state.appearences)

  return (
    <div className={styles.homePage}>
      <Hero
        herobanner={appearences?.herobanner}
      />
      <div className={styles.homeContent}>
        <CatSection />
        <AboutSection />
        <Carousel
          sliders={appearences?.sliders?.sliders}
        />
        <BrowseCat
          topCategories={appearences?.categories?.categories}
        />
        {/* <Brands /> */}
        <Feautred data={appearences?.featuredBrand || []} />
        {
          appearences?.popularProducts?.length > 0 &&
          <PopularProd popproduct={appearences?.popularProducts} />
        }
        <Features />
      </div>
    </div>
  )
}

export default Home
